export * from './config.js'
export * from './model-discovery.js'
export const name = '@tnega/config'
